import React from 'react'
import { CommonPublisherBaseFieldEntityOrSubEntity } from 'src/publisher/shared/components/field/common-publisher-base-field-entity-or-sub-entity'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { useFormField } from '../hooks/use-form-field'

interface FormEmailFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormEmailFieldSubEntity = ({
  fieldSubEntity,
}: FormEmailFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubEntity })
  return (
    <CommonPublisherBaseFieldEntityOrSubEntity
      type="email"
      entityOrSubEntity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
